import { useEffect } from 'react';

// Initialize Tawk_API globally
if (typeof window !== 'undefined') {
  window.Tawk_API = window.Tawk_API || {};
  window.Tawk_LoadStart = new Date();
  
  // Add a global function to update chat state from Tawk callbacks
  window.updateChatState = null;
}

const TawkChatWidget = () => {
  useEffect(() => {
    // Create Tawk.to script
    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = 'https://embed.tawk.to/687f8563828524191a317108/1j0p22448';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    
    // Hide the widget by default (will be shown via button click)
    window.Tawk_API.onLoad = function() {
      window.Tawk_API.hideWidget();
    };
    
    window.Tawk_API.onChatMinimized = function() {
      // When user minimizes chat, update our state
      if (typeof window.updateChatState === 'function') {
        window.updateChatState(false);
      }
    };
    
    window.Tawk_API.onChatMaximized = function() {
      // When user maximizes chat, update our state
      if (typeof window.updateChatState === 'function') {
        window.updateChatState(true);
      }
    };
    
    window.Tawk_API.onChatHidden = function() {
      // When chat is hidden, update our state
      if (typeof window.updateChatState === 'function') {
        window.updateChatState(false);
      }
    };
    
    // Append the script to the document
    document.head.appendChild(s1);
    
    // Clean up function to remove the script when component unmounts
    return () => {
      if (document.head.contains(s1)) {
        document.head.removeChild(s1);
      }
    };
  }, []);

  return null; // This component doesn't render anything
};

// Helper functions to control the widget
export const showTawkChat = () => {
  if (window.Tawk_API) {
    if (window.Tawk_API.showWidget) {
      window.Tawk_API.showWidget();
    }
    if (window.Tawk_API.maximize) {
      window.Tawk_API.maximize();
    }
    // Ensure the frame is visible
    const tawkFrame = document.getElementById('tawkchat-container');
    if (tawkFrame) {
      tawkFrame.style.display = 'block';
    }
  }
};

export const hideTawkChat = () => {
  if (window.Tawk_API) {
    if (window.Tawk_API.hideWidget) {
      window.Tawk_API.hideWidget();
    }
    if (window.Tawk_API.minimize) {
      window.Tawk_API.minimize();
    }
    // Force hide by adding CSS
    const tawkFrame = document.getElementById('tawkchat-container');
    if (tawkFrame) {
      tawkFrame.style.display = 'none';
    }
  }
};

export default TawkChatWidget;